// Commercial reference only. Never use this value as a relational identifier.
const commercialReference = (quoteNumber, versionNumber = 1) => {
  if (quoteNumber == null || quoteNumber === "") return "";
  if (typeof quoteNumber !== "string" || !quoteNumber.trim()) throw new TypeError("Numéro principal invalide.");
  const number = Number(versionNumber);
  if (!/^[1-9]\d*$/.test(String(versionNumber)) || !Number.isSafeInteger(number) || number > 2147483647) {
    throw new TypeError("Numéro de version invalide.");
  }
  return number === 1 ? quoteNumber : `${quoteNumber}-${number}`;
};

export { commercialReference };
